import { Box, Button, Heading, Modal, Text } from '@zillow/constellation-10';
import { PAYMENT_REPORTING_OPT_IN_SUCCESS_MODAL_MESSAGE } from '@renter-hub/constants/notificationMessages';
import CreditScoreImage from '@assets/creditScoreImage.png';

type Props = {
  onClose: () => void;
};

export const PaymentReportingOptInSuccessModal = (props: Props) => (
  <Modal
    open={true}
    trigger={null}
    size="md"
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        props.onClose();
      }
    }}
    header={<Heading level={2}>You’re all set!</Heading>}
    body={
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'loose',
        }}
      >
        <Box css={{ width: '300px' }}>
          {/* oxlint-disable-next-line next/no-img-element -- not a Next.js app (no next dependency, custom SSR server) */}
          <img src={CreditScoreImage as unknown as string} alt="Credit score meter" />
        </Box>
        <Text>{PAYMENT_REPORTING_OPT_IN_SUCCESS_MODAL_MESSAGE} </Text>
      </Box>
    }
    footer={
      <Button emphasis="filled" onClick={props.onClose}>
        Back to payments
      </Button>
    }
  />
);
